export type FilterType = 'ALL' | 'COORDINATE' | 'ITEM'
export type FilterName = 'すべて' | 'コーディネート' | 'アイテム'
export type FilterValue = undefined | 1 | 2

export const filterTypeNameMap: Record<FilterType, FilterName> = {
  ALL: 'すべて',
  COORDINATE: 'コーディネート',
  ITEM: 'アイテム',
}

export const filterNameTypeMap: Record<FilterName, FilterType> =
  Object.fromEntries(
    Object.entries(filterTypeNameMap).map(([k, v]) => [v, k] as const)
  )

export const filterTypeValueMap: Record<FilterType, FilterValue> = {
  ALL: undefined,
  COORDINATE: 1,
  ITEM: 2,
}

export const filterValueTypeMap: Record<`${FilterValue}`, FilterType> =
  Object.fromEntries(
    Object.entries(filterTypeValueMap).map(([k, v]) => [v, k] as const)
  )
